<template>
  <el-dialog
    class="number-of-treatment-wrapper"
    title="治疗次数"
    :visible.sync="diagnosisFormData.isShowNumberOfTreatmentDialog"
    :close-on-click-modal="false"
    width="60%"
  >
  <div class="dialog-box">
    <div class="content">
      <div class="head-wrap">
        <div class="head-item">
          <div class="title">总次数</div>
          <el-input v-model="totalNum" placeholder="请输入内容" @blur="totalNumBlur" @input="totalNum = totalNum.replace(/[^\d]/g, '')"></el-input>
        </div>
        <div class="head-item">
          <div class="title">当前次数</div>
          <el-input v-model="thisNum" placeholder="请输入内容" :disabled="true" @input="thisNum = thisNum.replace(/[^\d]/g, '')"></el-input>
        </div>
      </div>
      <div class="table-box">
        <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @row-click="handleCurrentChange"
        style="width: 100%">
        <el-table-column
          prop="item"
          label="美容/治疗项目"
        >
          <template slot-scope="scope">
            <div class="table-item" :title="scope.row.item">{{scope.row.item}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="advice"
          label="治疗设备/方法"
        >
          <template slot-scope="scope">
            <div class="table-item" :title="scope.row.advice">{{scope.row.advice}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="template"
          label="治疗模块/药物"
        >
          <template slot-scope="scope">
            <div class="table-item" :title="scope.row.template">{{scope.row.template}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalNum"
          label="总次数"
        >
          <template slot-scope="scope">
            <div class="table-item">{{scope.row.totalNum}}</div>
          </template>
        </el-table-column>
          <el-table-column
            prop="remainingNum"
            label="剩余次数"
          >
            <template slot-scope="scope">
              <div class="table-item">{{scope.row.remainingNum}}</div>
            </template>
          </el-table-column>
      </el-table>
      <div class="table-box-bg" v-if="disabledForModify"></div>
      </div>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <!--<el-button @click="diagnosisFormData.isShowNumberOfTreatmentDialog = false">取 消</el-button>-->
    <el-button type="primary" @click="confirm" class="foot-save-btn">保 存</el-button>
  </span>
  </el-dialog>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    
    inject: {
      diagnosisFormData: ['diagnosisFormData'],
      commonData: ['commonData'],
      addRelevantInfomation: ['addRelevantInfomation'],
    },
    
    data() {
      return {
        totalNum: '1',
        thisNum: '1',
        tableData: [
          /*{
            id: 1,
            totalNum: '10',
            remainingNum: '2',
            item: '瘢痕治疗',
            advice: 'DEKA',
            template: 'DOT+RF',
          },
          {
            id: 2,
            totalNum: '6',
            remainingNum: '4',
            item: '年轻化',
            advice: 'DEKA',
            template: 'DOT+RF',
          },
          {
            id: 3,
            totalNum: '5',
            remainingNum: '2',
            item: '瘢痕治疗',
            advice: 'DEKA',
            template: 'DOT+RF',
          }*/
        ],
        currentRow: null,
        // 是否生成表格数据
        timer: null,
        timer2: null,
        // 表格遮罩层是否显示，阻止点击
        disabledForModify: false,
      };
    },
  
    methods: {
      totalNumBlur() {
        if (this.totalNum && Number(this.totalNum) < Number(this.thisNum)) {
          this.$message.error('总次数不能小于当前次数');
        }
      },
      handleCurrentChange(row, event, column) {
        if (this.disabledForModify) {
          return;
        }
        if (this.currentRow) {
          if (this.currentRow.id === row.id) {
            this.$refs.singleTable.setCurrentRow();
            this.currentRow = null;
            this.totalNum = '1';
            this.thisNum = '1';
          } else {
            this.$refs.singleTable.setCurrentRow(row);
            this.currentRow = row;
            this.totalNum = row.totalNum;
            this.thisNum = String(row.totalNum - row.remainingNum + 1);
          }
        } else {
          this.currentRow = row;
          this.totalNum = row.totalNum;
          this.thisNum = String(row.totalNum - row.remainingNum + 1);
        }
      },
      async confirm() {
        if (this.totalNum && Number(this.totalNum) < Number(this.thisNum)) {
          this.$message.error('总次数不能小于当前次数');
          return;
        }
        if (this.currentRow) {
          this.commonData.parent_id = this.currentRow.treat_no;
        } else {
          this.commonData.parent_id = '';
        }
        this.commonData.thisNum = Number(this.thisNum);
        this.commonData.totalNum = Number(this.totalNum);
        this.diagnosisFormData.isShowNumberOfTreatmentDialog = false;
        const bool = await this.addRelevantInfomation();
        if (bool) {
          this.disabledForModify = true;
        }
      },
      // 查询列表
      async getCosmetologyTreatDetailsByPatient() {
        if (this.commonData.patientId === -1) {
          return;
        }
        try {
          const res = await this.$apollo.query({
            query: gql`{
              getCosmetologyTreatDetailsByPatient(patient_id: ${this.commonData.patientId}){
                id
                treat_no
                total_times
                left_times
                parent_id
                treat_details{
                  id
                  treat_no
                  item_info{
                    id
                    item_name
                  }
                  device_info{
                    id
                    device_name
                  }
                  module_info{
                    id
                    module_name
                  }
                }
                sub_relevant_info{
                  id
                  treat_no
                  total_times
                  left_times
                  parent_id
                  treat_details{
                    id
                    treat_no
                    item_info{
                      id
                      item_name
                    }
                    device_info{
                      id
                      device_name
                    }
                    module_info{
                      id
                      module_name
                    }
                  }
                }
              }
            }`,
            fetchPolicy: "no-cache",
          });
          this.tableData = this.handleArrayMethod(res.data.getCosmetologyTreatDetailsByPatient);
          
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 处理数组方法
      handleArrayMethod(arr) {
        for (const item of arr) {
          item.totalNum = item.total_times;
          item.remainingNum = item.left_times;
          if (item.sub_relevant_info.length === 0) {
            if (item.treat_details.length) {
              let itemText = '';
              let adviceText = '';
              let templateText = '';
              for (const item1 of item.treat_details) {
                if (item1.item_info) {
                  itemText += ('/' + item1.item_info.item_name);
                }
                if (item1.device_info) {
                  adviceText += ('/' + item1.device_info.device_name);
                }
                if (item1.module_info) {
                  templateText += ('/' + item1.module_info.module_name);
                }
              }
              item.item = itemText.substring(1);
              item.advice = adviceText.substring(1);
              item.template = templateText.substring(1);
            
            } else {
              item.item = '';
              item.advice = '';
              item.template = '';
            }
          } else {
            const item2 = item.sub_relevant_info[0];
            if (item2.treat_details.length) {
              let itemText = '';
              let adviceText = '';
              let templateText = '';
              for (const item1 of item2.treat_details) {
                if (item1.item_info) {
                  itemText += ('/' + item1.item_info.item_name);
                }
                if (item1.device_info) {
                  adviceText += ('/' + item1.device_info.device_name);
                }
                if (item1.module_info) {
                  templateText += ('/' + item1.module_info.module_name);
                }
              }
              item.item = itemText.substring(1);
              item.advice = adviceText.substring(1);
              item.template = templateText.substring(1);
    
            } else {
              item.item = '';
              item.advice = '';
              item.template = '';
            }
          }
        }
        return arr.filter((item) => item.left_times > 0);
      },
      // 继续治疗或时选中套餐操作
      selectCurrentRow(parent_id, total_times, current_times) {
        this.timer = setInterval(() => {
          if (this.$refs.singleTable) {
            clearInterval(this.timer);
            for (const item of this.tableData) {
              if (item.treat_no === parent_id) {
                this.$refs.singleTable.setCurrentRow(item);
                this.currentRow = item;
              }
            }
            this.totalNum = String(total_times);
            this.thisNum = String(current_times);
            this.disabledForModify = true;
          }
        }, 200);
      },
      // 编辑时选中套餐操作
      selectCurrentRowForModify(parent_id, total_times, current_times) {
        this.timer2 = setInterval(() => {
          if (this.$refs.singleTable) {
            clearInterval(this.timer2);
            for (const item of this.tableData) {
              if (item.treat_no === parent_id) {
                this.currentRow = item;
                this.$refs.singleTable.setCurrentRow(item);
              }
            }
            this.totalNum = String(total_times);
            this.thisNum = String(current_times);
            this.disabledForModify = true;
          }
        }, 200);
      },
    },
    
    mounted() {
      this.$root.$on('getCosmetologyTreatDetailsByPatient', () => {
        this.getCosmetologyTreatDetailsByPatient();
      });
      this.thisNum = String(this.commonData.thisNum);
      this.totalNum = String(this.commonData.totalNum);
    },
    
    beforeDestroy() {
      this.$root.$off('getCosmetologyTreatDetailsByPatient');
      clearInterval(this.timer);
      clearInterval(this.timer2);
    }
  
  }
</script>

<style>
  .number-of-treatment-wrapper .el-input__inner{
    font-weight: bold;
  }
  .number-of-treatment-wrapper .el-dialog__header{
    padding: 20px 25px 10px;
  }
  .number-of-treatment-wrapper .el-dialog__title{
    color: #4da3c0 !important;
    font-size: 20px;
    font-weight: 600;
  }
  .number-of-treatment-wrapper .el-dialog__close{
    color: #4da3c0 !important;
    font-size: 26px;
    font-weight: 700;
  }
  .number-of-treatment-wrapper .el-dialog__headerbtn{
    right: 25px;
  }
  .number-of-treatment-wrapper .el-dialog__body{
    padding: 0 15px;
  }
  .number-of-treatment-wrapper .cell{
    color: #000 !important;
    font-weight: bold !important;
    font-size: 15px !important;
    text-align: center !important;
  }
  .number-of-treatment-wrapper .el-table__body tr.current-row>td {
    background-color: rgb(159,201,224);
  }
</style>
<style lang="less" scoped>
  
  .dialog-box{
    .content{
      padding: 15px 10px 5px;
      border-top: 2px solid #4da3c0;
      .head-wrap{
        display: flex;
        width: 100%;
        .head-item{
          width: 49%;
          .title{
            color: #000;
            padding-left: 5px;
            padding-bottom: 5px;
            font-size: 15px;
            font-weight: bold;
          }
        }
        .head-item + .head-item{
          margin-left: 2%;
        }
      }
      .table-box{
        position: relative;
        padding: 10px 1px 0;
        .table-item{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          font-size: 15px;
          text-align: center;
        }
        .table-box-bg{
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .dialog-footer{
    padding-left: 5px;
    .foot-save-btn{
      width: 120px;
      height: 35px;
      padding: 0;
      line-height: 35px;
    }
  }
</style>
